export const PROJECT_NAME = "zeitlog";
export const SITE_URL = "https://zeitlog.github.io/";
export const PROJECT_URL = "https://github.com/zeitlog/";
export const DOCS_URL = "https://zeitdex.github.io/docs/";
